import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const StockAgeDistributionChart = ({ data }) => {
  const { t } = useTranslation();

  const componentColors = {
    "PRBC": "#e74c3c",
    "FFP": "#3498db",
    "Platelets": "#f1c40f",
  };

  const chartData = useMemo(() => {
    if (!data || !Array.isArray(data.ageRanges) || data.ageRanges.length === 0) return null;

    const datasets = Object.keys(data.components).map((component) => ({
      label: t(component),
      data: data.components[component],
      backgroundColor: componentColors[component] || "#666",
      borderColor: componentColors[component] || "#666",
      borderWidth: 1,
    }));

    return {
      labels: data.ageRanges,
      datasets,
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "top",
      labels: {
        fontColor: "#666",
        usePointStyle: true,
        padding: 15,
      },
    },
    tooltips: {
      mode: "index",
      intersect: false,
      callbacks: {
        label: (tooltipItem, chartData) => {
          const datasetLabel = chartData.datasets[tooltipItem.datasetIndex].label;
          return `${datasetLabel}: ${tooltipItem.yLabel} ${t("units")}`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
            max: 400,
            stepSize: 100,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Units per Stock"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: t("Storage Age"),
            fontColor: "#666",
          },
        },
      ],
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "350px", position: "relative" }}>
      <Bar data={chartData} height={350} options={options} />
    </div>
  );
};

export default StockAgeDistributionChart;
